import { OnboardingRepository } from "../../domain/repositories/OnboardingRepository";
import { OnboardingDataSource } from "../datasource/OnboardingDataSource";
import { AppConstants } from "../../../../core/constants/constants";
import Category from "../../domain/entities/category";
import UserInfo from "../../domain/entities/user";
import User from "../../domain/entities/getUser";
import ProfileConfig from "../../domain/entities/profileConfig";
import GetProfileConfigInfo from "../../domain/entities/getProfileConfigInfo";
import { UserTicket } from "../../domain/entities/userTicket";
import { ReferralCode } from "../../domain/entities/referralCode";
import {
	SignupPhotoLivenessCheckResult,
	SignupPhotoLivenessSaveResult,
} from "../../domain/entities/signupPhotoLiveness";

export class OnboardingRepositoryImpl implements OnboardingRepository {
	constructor(private dataSource: OnboardingDataSource) {}
	getUser(): Promise<User> {
		return AppConstants.getRightOrLeftSide<User>(this.dataSource.getUser());
	}
	updateUser(data: UserInfo): Promise<User> {
		return AppConstants.getRightOrLeftSide<User>(
			this.dataSource.updateUser(data)
		);
	}
	getCategories(endpoint: string): Promise<Category[]> {
		return AppConstants.getRightOrLeftSide<Category[]>(
			this.dataSource.getCategories(endpoint)
		);
	}
	sendProfileConfig(data: ProfileConfig): Promise<GetProfileConfigInfo> {
		return AppConstants.getRightOrLeftSide<GetProfileConfigInfo>(
			this.dataSource.sendProfileConfig(data)
		);
	}
	getProfileConfig(): Promise<GetProfileConfigInfo> {
		return AppConstants.getRightOrLeftSide<GetProfileConfigInfo>(
			this.dataSource.getProfileConfig()
		);
	}
	sendNewTicket(data: UserTicket): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.sendNewTicket(data)
		);
	}
	getReferralCode(): Promise<ReferralCode> {
		return AppConstants.getRightOrLeftSide<ReferralCode>(
			this.dataSource.getReferralCode()
		);
	}
	checkSignupPhotoLiveness(params: {
		file: File;
		maritalStatusId?: string;
	}): Promise<SignupPhotoLivenessCheckResult> {
		return AppConstants.getRightOrLeftSide<SignupPhotoLivenessCheckResult>(
			this.dataSource.checkSignupPhotoLiveness(params)
		);
	}
	saveSignupPhotoLivenessResult(params: {
		sessionId: string;
		contextToken: string;
	}): Promise<SignupPhotoLivenessSaveResult> {
		return AppConstants.getRightOrLeftSide<SignupPhotoLivenessSaveResult>(
			this.dataSource.saveSignupPhotoLivenessResult(params)
		);
	}
}
